export default class   EstadoCuentaPDFRequest {
    constructor(
        public userIdentity?: string,
        public tokenUser?: string,
        public accountCode?: string ,
        public batchNumber?: string ,
        public period?: string,
        public auditAttributes?:AuditAttributes,
        public pdfAttributes?:PDFAttributes
    ){}
}

export class AuditAttributes{
    constructor(
        public device?:string,
        public os?:string,
        public ip?:string,
        public version?:string,
    ){}

}
export class PDFAttributes{
    constructor(
        public title?:string,
         
    ){}}